export default __webpack_public_path__ + "7b814d73f7d5565212f5a1a4d926f4b2.glb";